
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "sonner";

const ToastListener = () => {
  const { message, type } = useSelector((state) => state.toast);

  useEffect(() => {
    if (message) {
      toast?.[type](message);
    }
  }, [message, type]);

  return null;
};

export default ToastListener;